import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useTranslation } from "@i18n";
import { useParams } from "react-router-dom";
import Loader from "@componentsShared/Loader/Loader";
import ViewAllOfferedDocComponent from "@/pages/tracking/components/SharedComponents/ViewAllOfferedDocComponent/ViewAllOfferedDocComponent";
import DeskTopBlueMobileWhiteHeader from "../../../../components/sharedComponents/DeskTopBlueMobileWhiteHeader/DeskTopBlueMobileWhiteHeader";
import stl from "./TrackingFinanceViewAllOfferedDoc.module.css";
import useHelpers from "@hooks/useHelpers";
import useApi from "@hooks/useApi";
import { api__getAllFinanceOfferedDoc } from "@/apis/orderTracking/api__getOrderTrackingList";
var TrackingFinanceViewAllOfferedDoc = function TrackingFinanceViewAllOfferedDoc() {
  var _useTranslation = useTranslation(["web_tracking"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useParams = useParams(),
    orderId = _useParams.orderId;
  var _useApi = useApi([orderId], function () {
      return api__getAllFinanceOfferedDoc(orderId);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error2 = _useApi2[1],
    allOfferedDoc = _useApi2[2];
  if (loading) return /*#__PURE__*/React.createElement(Loader, null);
  return /*#__PURE__*/React.createElement(Layout, {
    linksForSearch: true,
    mobileHasTitle: t("track_car_order", {
      ns: "web_tracking"
    }),
    hideOrangeHeadBtn: true,
    mobileHasBack: true,
    mobileNoLogo: true,
    headHideLinks: true,
    hideFooter: true,
    hideHeaderOnmobile: true,
    hideFooterWithoutAuthMsg: true
  }, /*#__PURE__*/React.createElement(DeskTopBlueMobileWhiteHeader, {
    title: t("documents", {
      ns: "web_tracking_finance"
    }),
    hasDeskTopBack: true,
    onClick: function onClick() {
      return navigateTo("/tracking-finance-details/".concat(orderId));
    },
    className2: stl.borderBottom
  }), /*#__PURE__*/React.createElement(ViewAllOfferedDocComponent, {
    orderId: orderId,
    allOfferedDoc: allOfferedDoc,
    isFinance: true
  }));
};
export default TrackingFinanceViewAllOfferedDoc;